import React from 'react';

// Skeleton item with shimmer effect
const SkeletonItem = ({className = '', style = {}}) => (
  <div
    className={`relative overflow-hidden bg-gray-200 rounded ${className}`}
    style={style}
  >
    <div
      className="absolute inset-0 animate-shimmer"
      style={{
        background:
          'linear-gradient(90deg, transparent 30%, rgba(255, 255, 255, 0.5) 50%, transparent 70%)',
        width: '200%',
        height: '100%',
      }}
    />
  </div>
);

// Skeleton loader for tier range section
export const TierRangeSkeleton = () => (
  <div className="border border-[#F7F7F7] rounded-2xl">
    <div className="bg-[#F7F7F7] py-2.5 px-6 rounded-t-2xl">
      <SkeletonItem className="h-4 w-32" />
    </div>
    <div className="pt-5 px-6 pb-8">
      <div className="mb-4">
        <SkeletonItem className="h-3.5 w-16 mb-2" />
        <SkeletonItem className="h-3 w-72" />
      </div>
      <div className="relative !mt-8">
        <SkeletonItem className="h-4 w-full" />
      </div>
      <div className="flex items-center gap-4 mt-4">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="flex items-center gap-2">
            <SkeletonItem className="h-2.5 w-2.5 rounded-full" />
            <SkeletonItem className="h-3 w-16" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Skeleton loader for setup conditions section
export const SetupConditionsSkeleton = () => (
  <div className="border border-[#F7F7F7] rounded-2xl mt-8">
    <div className="bg-[#F7F7F7] py-2.5 px-6 rounded-t-2xl">
      <SkeletonItem className="h-4 w-36" />
    </div>
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-11 bg-white rounded-b-2xl">
      {[1, 2, 3, 4].map(i => (
        <div key={i} className="bg-[#F9F9F9] p-4 rounded-lg">
          <SkeletonItem className="h-4 w-4/5 mb-4" />
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <SkeletonItem className="h-3 w-20 mb-2" />
              <SkeletonItem className="h-10 w-full" />
            </div>
            <div>
              <SkeletonItem className="h-3 w-20 mb-2" />
              <SkeletonItem className="h-10 w-full" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton loader for action buttons
export const ActionButtonsSkeleton = () => (
  <div className="flex items-center gap-2 justify-end my-6">
    <SkeletonItem className="h-10 w-24" />
    <SkeletonItem className="h-10 w-32" />
  </div>
);

